import { channelPartnerKeyScopeKey as e } from "./channelPartnerKeyScopeKey.mjs";
import { useTrEnumNamespace as t } from "./useTrEnumNamespace.mjs";
import { useCallback as n } from "react";
//#region src/enums/useTrAdminMcpKeyScope.ts
var r = () => {
	let r = t("adminMcpKeyScope");
	return n((t) => {
		let n = e(t), i = r(n);
		return i === n ? t : i;
	}, [r]);
};
//#endregion
export { r as useTrAdminMcpKeyScope };
